import { useBusinessContext } from "@/providers/business-provider";

export function useSelectedBusiness() {
  return useBusinessContext();
}